/**
 * Valid Fields for Voluntary Life & AD&D Benefits
 *
 * Used to filter out fields that don't belong to this coverage type when saving to API.
 */

export const VOLUNTARY_LIFE_VALID_FIELDS = new Set([
  "objectType",

  // Employee nested object
  "employee",

  // Spouse nested object
  "spouse",

  // Child nested object
  "child",

  // Definition of Earnings
  "definitionOfEarnings",

  // Simple fields
  "adndIncluded",
  "adndTiedToLife",
  "ageReductionSchedule",
  "conversion",
  "acceleratedDeathBenefit",
  "waiverOfPremium",
  "annualOpenEnrollment",
  "portability",

  // Extended (non-v5) fields — CD-2071
  "extended",
]);
